import React, { Component, Fragment } from "react"
import actions from "./actions/root_action"
import { connect } from "react-redux"
import { withNamespaces } from "react-i18next"
import { compose } from "redux"
import Modal from '../../common/components/modal_dialog/modal_wrapper_component'
import "./main_container.scss"
import lozad from 'lozad'

const imgdir = '/assets/image/campaigns/yamawake202210'

export class Main extends Component {
  async componentDidMount() {
    const observer = lozad()
    observer.observe()
  }

  render() {
    return (
      <React.Fragment>
        <div styleName="container">
          <h1>
            <img className="lozad" data-src={`${imgdir}/eyecatch-pc.png`} styleName="eye-catch" alt="Rakuten Oyado登録部屋数10万室突破記念！ 10万ポイント山分けキャンペーン"/>
            <img className="lozad" data-src={`${imgdir}/eyecatch-sp.png`} styleName="eye-catch sp-only" alt="Rakuten Oyado登録部屋数10万室突破記念！ 10万ポイント山分けキャンペーン"/>
          </h1>
          <div styleName="cpn-term">
            <div>
              <span>エントリー期間： </span>
              <span>2022年10月3日(月) ～ 2022年10月31日(月)</span>
            </div>
            <div>
              <span>対象宿泊期間： </span>
              <span>2022年10月3日(月) ～ 2022年11月30日(水)チェックアウト</span>
            </div>
          </div>
          <div styleName="block cpn-note">
            ※進呈するポイント（期間限定ポイント含）には上限や条件があります。詳しくはキャンペーン詳細をご確認ください。<br/>
            ※本キャンペーンは予告なく中止、変更する場合があります。予めご了承ください。
          </div>
          <div styleName="block">
            <div styleName="info">
              本キャンペーンは終了しました。
            </div>
          </div>
          <div styleName="block">
            <div id="entry-button" styleName="entry-button-disabled">エントリーはこちら</div>
            {/* <div styleName="entry-button-caption">エントリーには楽天IDログインが必要です。</div> */}
          </div>
          <section>
            <h2 styleName="section-header">キャンペーン参加方法</h2>
            <div styleName="block text-center">
              <div styleName="steps">
                <img className="lozad" data-src={`${imgdir}/step1.png`} />
                <img className="lozad" data-src={`${imgdir}/step2.png`} />
              </div>
              <img styleName="insentive" className="lozad" data-src={`${imgdir}/insentive.png`} />
            </div>
          </section>
          <section styleName="cpn-details">
            <h2 styleName="section-header">キャンペーン詳細</h2>
            <div styleName="block">
              <h3>キャンペーン内容</h3>
              <p>下記対象期間中に当該キャンペーンのログインフォームよりご応募(エントリー)いただき、Rakuten Oyado上で宿泊施設をご予約し､楽天IDにて決済し、実際にご宿泊された方に楽天ポイントを通常ポイント(1％)に加えて、下記のとおり還元いたします｡（エントリーした際の楽天IDを用いたご予約に限ります）<br/>・宿泊・・・10万ポイントの楽天ポイントを「山分け」にて還元</p>

              <h3>キャンペーン対象者</h3>
              <p>下記対象期間中に当該キャンペーンのログインフォームよりご応募(エントリー)いただき、Rakuten Oyado上で宿泊施設を予約し､楽天IDにて決済し、実際にご宿泊された方</p>

              <h3>対象サービス</h3>
              <p>Rakuten Oyado</p>

              <h3>エントリー受付期間</h3>
              <p>2022年10月3日(月) 00:00 ～ 2022年10月31日(月) 23:59</p>
              <div styleName="note">
                ※本キャンペーンはエントリー制です。キャンペーンに参加するにはエントリーが必要です。
              </div>

              <h3>予約期間</h3>
              <p>2022年10月3日(月) 00:00 ～ 2022年10月31日(月) 23:59</p>

              <h3>宿泊期間</h3>
              <p>2022年10月3日(月)チェックイン ～ 2022年11月30日(水)チェックアウト</p>
              <div styleName="note">※予約が先でもエントリーが先でもキャンペーン期間中であれば対象となります。</div>

              <h3>特典ポイント</h3>
              <p>・宿泊・・・10万ポイントの楽天ポイントを「山分け」にて還元</p>
              <div styleName="note">
                ※特典ポイントは、1件あたりのご宿泊につき、山分けの口数が加算されます。<br/>
                ※お一人様あたりの獲得できる特典ポイントの上限は10,000ポイントとなります。<br/>
                ※特典ポイントを山分けする際に発生するポイントの小数点以下は切り捨ていたします。<br/>
                ※山分けポイント以上のご参加があった場合、お一人様あたり1ポイントの進呈となります。山分け対象となるご投稿口数の合計が10万口を超える場合、先着(エントリーと予約を完了された)10万名様に還元いたします。<br/>
                ※予約者と利用者が異なっても対象となります。 楽天ポイントは予約者の楽天IDに還元されます。<br/>
                ※ポイント還元時点でキャンセルとなっているご予約は対象外となります。
              </div>

              <h3>特典ポイント還元時期</h3>
              <p>
                当該キャンペーンの特典ポイントは、通常サービス利用で還元されるポイントとは別に2022年12月31日頃までに還元いたします。キャンペーン終了後、特典ポイント還元まで期間がありますのでご注意ください。
              </p>
              <div styleName="note">
                ※獲得したポイントは、楽天ポイント履歴画面でご確認ください。<br/>
                ※1ヶ月でご利用いただけるポイントは、「ポイント利用可能サービス」での利用額を合算して10万ポイントが上限(ダイヤモンドランクの会員様は50万ポイントまで)です。上限を超えるポイントを獲得された場合、ポイントがご利用いただけないまま失効する事がございますので、あらかじめご了承ください。<br/>
                期間限定ポイントについては<a target="_blank" href="https://point.rakuten.co.jp/guidance/terms/">こちら</a>をご参照ください。
              </div>

              <h3>注意事項</h3>
              <ul>
                <li>アクセス集中やメンテナンスなどによりキャンペーン対象期間中のご利用ができなかった場合、キャンペーン対象外となります。詳細はこちらをご確認ください。</li>
                <li>特典ポイント獲得の権利は譲渡できません。</li>
                <li>本キャンペーンの対象予約が､別途エントリーいただいているRakuten Oyado　主催の他キャンペーンにおいても特典ポイントの対象となる場合は､いずれかのキャンペーンを優先し､優先されたキャンペーンの特典ポイントのみを還元させていただく場合がございますので予めご了承ください｡</li>
                <li>キャンペーン内容は予告なく変更・終了することがあります。予めご了承ください。</li>
              </ul>
            </div>
          </section>
        </div>
        <Modal />
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    login: state.login,
    language: state.language,
    modal: state.modal
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: actions(dispatch)
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withNamespaces()
)(Main)
